import { GoogleColoredIcon } from "../../../../../icons";

import { useMemo } from "react";
import { useUserProfileQuery } from "../../../../../react-query/user/queries";

const CalendarAccount = () => {
  const { data: userProfile } = useUserProfileQuery();
  const userEmail = useMemo(() => userProfile?.email, [userProfile?.email]);
  return (
    <div
      className="border-3 flex w-full items-center gap-2 border-white border-opacity-100 px-[6px] py-2"
      style={{
        borderTop: "1px solid var(--w-8_hover)",
        borderBottom: "1px solid var(--w-8_hover)",
      }}
    >
      <GoogleColoredIcon
        w={4}
        h={4}
      />
      <p className="text-body1 text-white">{userEmail}</p>
    </div>
  );
};

export default CalendarAccount;
